let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("98wVx"), load("ahwM1"), load("6XyGC")]).then(() => parcelRequire('cV69w'));